<template>
    <div v-bind:class="name">
        <div ref="inner" v-bind:class="name+'-inner'" class="u-absolute u-pos-tl u-fit u-bg--white"></div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import { pointerdown, pointermove, pointerup } from '@/utilities/pointer';
    import getPrefix from '@/utilities/getPrefix';

    export default {
        name: 'VideoTimeline',

        props: {
            active: { type: Boolean, default: true },
            pourcent: { type: Number, default: 0 },
            onSeek: { type: Function, default: () => this },
            name: { type: String, default: 'c-video-timeline' },
        },

        watch: {
            active: 'onActiveChange',
            pourcent: 'onPourcentChange',
        },

        computed: {
            ...mapState('window', [
                'isTouch',
            ]),
        },

        created() {
            this.x = 0;

            this._onPointerDown = this.onPointerDown.bind(this);
            this._onPointerMove = this.onPointerMove.bind(this);
            this._onPointerUp = this.onPointerUp.bind(this);
        },

        mounted() {
            this.$el.addEventListener(pointerdown, this._onPointerDown);
            this.$el.addEventListener(pointermove, this._onPointerMove);
            this.$el.addEventListener(pointerup, this._onPointerUp);

            this.$eventHub.$on('resize', this.resize);
            this.$eventHub.$on('update', this.update);

            this.resize();
        },

        beforeDestroy() {
            this.$el.removeEventListener(pointerdown, this._onPointerDown);
            this.$el.removeEventListener(pointermove, this._onPointerMove);
            this.$el.removeEventListener(pointerup, this._onPointerUp);

            this.$eventHub.$off('resize', this.resize);
            this.$eventHub.$off('update', this.update);
        },

        methods: {
            resize() {
                this.width = this.$el.clientWidth;
                this.height = this.$el.clientHeight;

                this.offsetX = this.$el.getBoundingClientRect().left;
            },

            onPointerDown(event) {
                this.isPointerDown = true;

                const pageX = this.isTouch ? (event.touches[0].pageX || event.changedTouches[0].pageX) : event.clientX;
                this.track(pageX);
            },

            onPointerMove(event) {
                if (!this.isPointerDown) return;
                if (event) event.preventDefault();

                const pageX = this.isTouch ? (event.touches[0].pageX || event.changedTouches[0].pageX) : event.clientX;
                this.track(pageX);
            },

            onPointerUp() {
                if (!this.isPointerDown) return;

                this.isPointerDown = false;
                this.onSeek(this.newPourcent);
            },

            track(pageX) {
                const val = pageX - this.offsetX;

                if (val >= 0 && val <= this.width) {
                    this.x = val;
                    this.newPourcent = this.x / this.width;
                }
            },

            onPourcentChange() {
                this.x = this.pourcent * this.width;
            },

            update() {
                if (!this.active) return;
                this.$refs.inner.style[getPrefix('transform')] = `translateX(${(-this.width + this.x)}px) translateZ(0)`;
            },
        },
    };
</script>


<style lang="stylus">
    @import '../styles/settings/*'

    .c-video-timeline {
        width 100%
        height 24px

        cursor pointer

        &:before {
            content ""
            position absolute
            bottom 0
            left 0

            width 100%
            height 4px
            background #FFF
            opacity 0.2
        }

        &-inner {
            top auto
            height 4px
            bottom 0
        }
    }
</style>
